import type { SystemRelationshipTarget } from '@cli-types/core-engine/schema.js'
import { isUserRelationshipTarget } from './is-user-relationship-target.js'

export function isSystemRelationshipTarget(
  relationship: string | null | undefined
): relationship is SystemRelationshipTarget {
  return isUserRelationshipTarget(relationship)
}
